import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import bg_logo_img from '../../assets/images/logo_blk_bgwhite.jpg';
import '../../assets/css/AboutUs.css';
import '../../assets/css/Packages.css';
import '../../assets/css/Contact.css';
import '../../assets/css/BlogDetail.css';
// import { EditNotifications } from '@mui/icons-material';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEnvelope, faLocationDot, faPhone, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
// import tpd1 from '../../assets/images/tpd1.png';
// import ProfileTab from '../../Components/Profile/ProfileTabs';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleTipApi } from '../../Redux/Auth/Auth_Action';


const TipsDetails = () => {
    const paramData = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const reduxState = useSelector((state) => state);
    // console.log('daaaaaaaaaaaaaaaa',reduxState);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    const [state, setState] = useState({ SingleTip: [] });
    // console.log(paramData);

    const getSingleTips = () => {
        dispatch(getSingleTipApi(paramData.id, paramData.category, reduxState.Auth.token))
            .then((res) => {
                // console.log('response from tips details', res.data.response.data[0]);
                setState({ ...state, SingleTip: res.data.response.data[0] });
            })
            .catch((e) => {
                console.log('error from tipsdetails', e);
            })
    }

    useEffect(() => {
        getSingleTips();
    }, []);

    // console.log('from tip details', state);

    return (
        <div className='Contact packages blog-details'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"TIPS"} />
            </section>
            <section className='blogDetail-content'>
                <div className='container'>
                    <div >
                        <div className='img-box'>
                            {
                                (state?.SingleTip?.media)
                                    ?
                                    <>
                                        {(state?.SingleTip?.media_url?.slice(-3) === "mp4")
                                            ?
                                            <video width="100%" height="500" controls controlsList="nodownload" >
                                                <source src={`${state?.SingleTip?.media_url}`} type="video/mp4" />
                                            </video>
                                            :
                                            <img src={state?.SingleTip?.media_url} alt="Tellus id interdum velit laoreet" className='image-fluid image-width' />
                                        }
                                    </>
                                    :
                                    <>
                                        <img className='image-fluid image-width' src={bg_logo_img} alt="tips"></img>
                                    </>
                            }

                        </div>
                        <p className='blog-title'>{state?.SingleTip?.title}
                        </p>
                        <p className='time'>Posted On : {" "}
                            {/* {state?.SingleTip?.updated_at?.slice(0, 10)} */}
                            <span className='ml-1'>{state?.SingleTip?.updated_at?.slice(5, 7)}</span>
                            <span>{state?.SingleTip?.updated_at?.slice(7, 10)}</span>
                            <span>-{state?.SingleTip?.updated_at?.slice(0, 4)}</span>
                            {" "}| {" "}Posted by {" "}: {" "}{state?.SingleTip?.posted_by}</p>
                        <div className='brkbrk' dangerouslySetInnerHTML={{ __html: state?.SingleTip?.description }}>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default TipsDetails;
